import { render, staticRenderFns } from "./TopJettonPercentChange.vue?vue&type=template&id=8fa9a60e"
import script from "./TopJettonPercentChange.vue?vue&type=script&lang=js"
export * from "./TopJettonPercentChange.vue?vue&type=script&lang=js"
import style0 from "./TopJettonPercentChange.vue?vue&type=style&index=0&id=8fa9a60e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports